/**
 * Vleys, Wishlist Hero Navbar
 * Erkennt gefuellte Liste an der Klasse "wishlist-hero-items-count-exists"
 * (von der App gesetzt) plus display-Fallback. Kein body-Observer.
 */
(function () {
  'use strict';

  var SOLID_PATH = 'M23.6 2c-3.4 0-6.3 2.7-7.6 5.1C14.7 4.7 11.8 2 8.4 2 3.8 2 0 5.8 0 10.4c0 7.4 9 12.6 15.3 18.7.4.4 1 .4 1.4 0C23 23 32 17.8 32 10.4 32 5.8 28.2 2 23.6 2z';
  var emptyPath = null;

  function hasItems() {
    var header = document.querySelector('.wishlist-hero-header-icon');
    if (!header) return false;
    var counter = header.querySelector('.wishlist-hero-items-count');
    if (!counter) return false;
    if (counter.classList.contains('wishlist-hero-items-count-exists')) return true;
    if (window.getComputedStyle(counter).display === 'none') return false;
    return false;
  }

  function syncHeader() {
    var header = document.querySelector('.wishlist-hero-header-icon');
    if (!header) return;
    var path = header.querySelector('svg path');
    if (emptyPath === null && path && !hasItems()) {
      emptyPath = path.getAttribute('d');
    }
    if (hasItems()) {
      header.setAttribute('data-wlh-has-items', '');
      header.style.setProperty('color', '#000000', 'important');
      if (path) path.setAttribute('d', SOLID_PATH);
    } else {
      header.removeAttribute('data-wlh-has-items');
      header.style.removeProperty('color');
      if (path && emptyPath) path.setAttribute('d', emptyPath);
    }
  }

  function start() {
    syncHeader();
    setInterval(syncHeader, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
